import React, { useState, useEffect } from "react";
import api, { API } from "../lib/api";

// Displays a stored photo by fetching it as an authenticated blob.
export const AuthImage = ({ path, className, onClick }) => {
    const [src, setSrc] = useState(null);
    useEffect(() => {
        let url;
        let mounted = true;
        (async () => {
            try {
                const resp = await api.get(`/files/${path}`, { responseType: "blob" });
                url = URL.createObjectURL(resp.data);
                if (mounted) setSrc(url);
            } catch (e) { /* ignore */ }
        })();
        return () => { mounted = false; if (url) URL.revokeObjectURL(url); };
    }, [path]);

    if (!src) return <div className={`animate-pulse bg-muted ${className}`} />;
    return <img src={src} alt="Rotina" className={className} onClick={onClick} />;
};
